import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Input from "@streeteasy/design-system/deprecated/Input";
import Text from "@streeteasy/design-system/deprecated/Text";
import TextArea from "@streeteasy/design-system/deprecated/TextArea";
import Title from "@streeteasy/design-system/deprecated/Title";
import { darken } from "polished";

const BannerShareLink = styled(Text).attrs({
  type: "disclaimer"
})`
  background: ${colors.mouseGrey};
  color: ${colors.pureBlack};
  height: 38px;
  margin: 15px 0 0;
  padding: 11px 0;
  text-align: center;
  width: 100%;

  @media screen and (max-width: 660px) {
    line-height: 15px;
    padding: 10px 67px 40px;
  }
`;

const DynamicGroup = styled.div`
  > * {
    position: relative;

    &:nth-child(2) {
      top: -1px;
    }

    &:nth-child(3) {
      top: -2px;
    }
  }
`;

const DynamicField = styled(Input)`
  z-index: ${props => (props.isInvalid ? "2" : "1")};
`;

const Location = styled(Title)`
  color: ${colors.koalaGrey};
`;

const LocationSpacer = styled.div`
  padding: ${props => (props.isAgent ? "16px 0 6px" : "30px 0 6px")};

  @media screen and (max-width: 660px) {
    padding: 28px 0 6px;
  }
`;

const ModalContainer = styled.div`
  background-color: white;
  box-sizing: border-box;
  min-height: 300px;
  padding: 35px 70px 50px;
  width: 580px;

  @media screen and (max-width: 660px) {
    min-height: 100vh;
    padding: 0 20px 50px;
    position: absolute;
    top: 0;
    width: 100%;
  }

  * {
    box-sizing: border-box;
  }
`;

const ModalErrorBox = styled.div`
  color: red;
`;

const ModalFooter = styled.div`
  padding: 22px 0 0;
  text-align: center;
`;

const ModalHeader = styled.div`
  padding: ${props => (props.isAgent ? "20px 0 15px" : "20px 0 28px")};

  @media screen and (max-width: 660px) {
    padding: ${props => (props.isAgent ? "0 0 15px" : "0 0 26px")};
  }
`;

const ModalHeaderMobile = styled.div`
  display: none;

  @media screen and (max-width: 660px) {
    background-color: ${colors.ink};
    display: block;
    margin: 0 -20px;
    z-index: 2;
  }
`;

const ModalInputBox = styled.div`
  padding: 19px 0 30px;
  text-align: left;

  @media screen and (max-width: 660px) {
    padding: 26px 0 27px;
  }
`;

const ModalLink = styled.a`
  color: ${colors.koalaGrey};
  margin: 0 0 0 3px;
  text-decoration: underline;

  &:hover {
    color: ${darken(0.1, colors.koalaGrey)};
  }

  &:active {
    color: ${darken(0.2, colors.koalaGrey)};
  }
`;

const ModalMainTitle = styled(Title)`
  @media screen and (max-width: 660px) {
    display: none;
  }
`;

const ModalRecaptcha = styled.div`
  border-bottom: 1px solid ${colors.rabbitGrey};
  padding: 0 0 27px;

  @media screen and (max-width: 660px) {
    padding: 0 0 25px;
  }
`;

const ModalSubmitBox = styled.div`
  padding: ${props => (props.isNoPadding ? "0" : "30px 0 0")};

  @media screen and (max-width: 660px) {
    padding: 28px 0 0;
  }
`;

const ModalTextArea = styled(TextArea)`
  padding: 10px 15px 15px;

  &::-webkit-input-placeholder {
    color: ${colors.koalaGrey};
    font-weight: 100;
  }

  &::-moz-placeholder {
    color: ${colors.koalaGrey};
    font-weight: 100;
  }

  &:-ms-input-placeholder {
    color: ${colors.koalaGrey};
    font-weight: 100;
  }

  &:-moz-placeholder {
    color: ${colors.koalaGrey};
    font-weight: 100;
  }

  @media screen and (max-width: 660px) {
    height: 110px;
  }
`;

const ModalTitle = styled(Title)`
  @media screen and (max-width: 660px) {
    color: white;
    padding: 13px;
    text-align: center;
  }
`;

const ErrorText = styled(Text)`
  color: ${colors.errorRed};
  font-size: 12px;
  padding-top: 7px;
`;

BannerShareLink.displayName = "BannerShareLink";
DynamicField.displayName = "DynamicField";
DynamicGroup.displayName = "DynamicGroup";
ErrorText.displayName = "ErrorText";
Location.displayName = "Location";
LocationSpacer.displayName = "LocationSpacer";
ModalContainer.displayName = "ModalContainer";
ModalErrorBox.displayName = "ModalErrorBox";
ModalFooter.displayName = "ModalFooter";
ModalHeader.displayName = "ModalHeader";
ModalHeaderMobile.displayName = "ModalHeaderMobile";
ModalInputBox.displayName = "ModalInputBox";
ModalLink.displayName = "ModalLink";
ModalMainTitle.displayName = "ModalMainTitle";
ModalRecaptcha.displayName = "ModalRecaptcha";
ModalSubmitBox.displayName = "ModalSubmitBox";
ModalTextArea.displayName = "ModalTextArea";
ModalTitle.displayName = "ModalTitle";

export {
  BannerShareLink,
  DynamicField,
  DynamicGroup,
  ErrorText,
  Location,
  LocationSpacer,
  ModalContainer,
  ModalErrorBox,
  ModalFooter,
  ModalHeader,
  ModalHeaderMobile,
  ModalInputBox,
  ModalLink,
  ModalMainTitle,
  ModalRecaptcha,
  ModalSubmitBox,
  ModalTextArea,
  ModalTitle
};
